import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../app.constants';

import { User } from '../../shared/classes/user';
import { AuthenticationService } from '../../shared/services/authentication.service';

@Injectable()
export class UserService {
  private _url = this._configuration.apiUrl + "/v2/user";
  // Use API
  private _printersUrl = this._configuration.apiUrl + "/v2/printer";
  private _rolesUrl = this._configuration.apiUrl + "/v2/role";
  private _rightsUrl = this._configuration.apiUrl + "/v2/role";
  private _languagesUrl = this._configuration.apiUrl + "/v2/language";
  private headers: Headers;

  constructor(private _http: Http, private _configuration: Configuration, public _authService: AuthenticationService) {
    this.headers = this._authService.getHeaders();
    //this.headers.append("Content-Type", "application/json");
    //this.headers.append("Accept", "application/json");
  }

  getAllUsers(): Observable<User[]> {
    return this._http.get(this._url, { headers: this.headers }).map(
      (response: Response) => {
        let body = response.json();
        if (body['users'] == null || !Array.isArray(body['users'])) {
          return [];
        }
        return body['users'];
      })
  }

  getOneUser(id: string): Observable<User> {
    let search: URLSearchParams = new URLSearchParams();

    search.append('id', id);

    return this._http.get(this._url, { headers: this.headers, search: search }).map(
      (response: Response) => {
        let body = response.json();
        if (body['users'] == null || !Array.isArray(body['users']) || body['users'].length == 0) {
          return [];
        }
        return body['users'][0];
      })
  }

  addOneUser(user: User) {
    return this._http.post(this._url, user, { headers: this.headers }).map(response => response.json());
  }

  updateOneUser(user: User) {
    let search: URLSearchParams = new URLSearchParams();

    search.append('id', user.id);

    return this._http.put(this._url, user, { headers: this.headers, search: search }).map(response => response.json());
  }

  deleteOneUser(user: User) {
    let search: URLSearchParams = new URLSearchParams();

    search.append('id', user.id);

    return this._http.delete(this._url, { headers: this.headers, search: search }).map(response => Object.assign(response.json(), { id: user.id }));
  }

  getRoles(): Observable<any[]> {
    return this._http.get(this._rolesUrl, { headers: this.headers }).map(
      (response: Response) => {
        let body = response.json();
        if (body['roles'] == null || !Array.isArray(body['roles'])) {
          return [];
        }
        return body['roles'];
      })
  }

  getPrinters(): Observable<any[]> {
    return this._http.get(this._printersUrl, { headers: this.headers }).map(
      (response: Response) => {
        let body = response.json();
        if (body['printers'] == null || !Array.isArray(body['printers'])) {
          return [];
        }
        return body['printers'].map(p => ({ id: Number.parseInt(p.id), name: p.name }));
      })
  }

  getRights(): Observable<any[]> {
    return this._http.get(this._rightsUrl, { headers: this.headers }).map(
      (response: Response) => {
        let body = response.json();
        if (body['rights'] == null || !Array.isArray(body['rights'])) {
          return [];
        }
        return body['rights'];
      })
  }

  getLanguages(): Observable<any[]> {
    return this._http.get(this._languagesUrl, { headers: this.headers }).map(
      (response: Response) => {
        let body = response.json();
        if (body['languages'] == null || !Array.isArray(body['languages'])) {
          return [];
        }
        return body['languages'];
      })
  }

  changePassword(user_id: string, password: string) {
    let search: URLSearchParams = new URLSearchParams();

    search.append('id', user_id);
    search.append('passwordOnly', 'true');

    return this._http.put(this._url, { password: password }, { headers: this.headers, search: search }).map(response => response.json());
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/admin/user.service.ts